<button class="button has-icon is-fullwidth" [class.is-info]="state" (click)="toggle.emit(!state)" >
  <i *ngIf="state"  class="fa fa-check-square-o"></i>
  <i *ngIf="!state" class="far fa-square"></i>
  <span style="margin-left:0.35em; font-size:90%; flex-grow: 4;">
    {{caption}}
  </span>
</button>
